<template>
  <div class="guide">
    <div v-if="isPc" class="guide-menu">
      <div class="guide-type" v-for="item in tabsList" :key="item.type_name">
        <h3>
          <img
            :src="
              'https://www.sztmas.cn/sztx/assets/imgs/guide' +
              item.type_id +
              '.png'
            "
          />
          {{ item.type_name }} ：
        </h3>
        <div>
          <ul>
            <li
              v-for="(it, idx) in item.child"
              :key="it.childName"
              @click="
                toOutSideUrl(item.type_id, item.child.length !== 1 ? idx : '')
              "
            >
              {{ it.childName }}
            </li>
          </ul>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
    <div class="m-guide-menu" v-else>
      <el-menu :unique-opened="true" default-active="1">
        <el-submenu
          :index="index"
          v-for="(item, index) in tabsList"
          :key="item.type_name"
        >
          <template slot="title">
            <img
              class="icon"
              :src="
                'https://www.sztmas.cn/sztx/assets/imgs/guide' +
                item.type_id +
                '.png'
              "
            />
            <span>{{ item.type_name }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              index="1-1"
              v-for="(it, idx) in item.child"
              :key="it.childName"
              @click="
                toOutSideUrl(item.type_id, item.child.length !== 1 ? idx : '')
              "
              >{{ it.childName }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      activeIndex: "0",
      tabsList: [
        {
          type_name: "深圳城市概況",
          type_id: "01",
          child: [
            {
              childName: "深圳城市概況",
              type_id: "",
            },
          ],
        },
        {
          type_name: "個人",
          type_id: "02",
          child: [
            {
              childName: "台灣居民出入境證件辦理",
              type_id: "02",
            },
            {
              childName: "面向台灣居民開放的專業资格考試類別",
              type_id: "02",
            },
            {
              childName: "台灣居民辦理駕駛證",
              type_id: "02",
            },
            {
              childName: "台灣居民在大陸永久居住",
              type_id: "02",
            },
            {
              childName: "台灣居民辦理台灣居民居住證辦法",
              type_id: "02",
            },
            {
              childName: "台灣居民在深圳購買居住用房",
              type_id: "02",
            },
            {
              childName: "台灣居民在深圳就醫回台灣健保報销須知",
              type_id: "02",
            },
            {
              childName: "台灣居民辦理銀行個人業務須知",
              type_id: "02",
            },
            {
              childName: "辦理電信服務須知",
              type_id: "02",
            },
            {
              childName: "台灣居民在深圳參加社會保險辦法",
              type_id: "02",
            },
          ],
        },
        {
          type_name: "家庭",
          type_id: "03",
          child: [
            {
              childName: "涉台(陸)婚姻須知",
              type_id: "03",
            },
            {
              childName: "台灣居民子女深圳就學",
              type_id: "03",
            },
            {
              childName: "台灣居民在深圳身故後的相關手績辦理",
              type_id: "03",
            },
            {
              childName: "台灣居民辦理公證",
              type_id: "03",
            },
          ],
        },
        {
          type_name: "經營",
          type_id: "04",
          child: [
            {
              childName: "台灣居民申請個體工商戶",
              type_id: "04",
            },
            {
              childName: "台灣居民申辦企業流程",
              type_id: "04",
            },
            {
              childName: "台灣居民申請專利辦法及專利扶持政策",
              type_id: "04",
            },
            {
              childName: "新辦企業聘請員工須知",
              type_id: "04",
            },
            {
              childName: "企業為員工繳交「五險一金」",
              type_id: "04",
            },
          ],
        },
        {
          type_name: "糾紛解決",
          type_id: "05",
          child: [
            {
              childName: "公安局及下辖分局、派出所",
              type_id: "05",
            },
            {
              childName: "仲裁機構",
              type_id: "05",
            },
            {
              childName: "法院",
              type_id: "05",
            },
          ],
        },
        {
          type_name: "健康深圳",
          type_id: "06",
          child: [
            {
              childName: "深圳主要醫院",
              type_id: "06",
            },
            {
              childName: "深圳運動",
              type_id: "06",
            },
          ],
        },
        {
          type_name: "文藝深圳",
          type_id: "07",
          child: [
            {
              childName: "文藝深圳",
              type_id: "",
            },
          ],
        },
        {
          type_name: "暢遊深圳",
          type_id: "08",
          child: [
            {
              childName: "暢遊深圳",
              type_id: "",
            },
          ],
        },
        {
          type_name: "食在深圳",
          type_id: "09",
          child: [
            {
              childName: "常用App",
              type_id: "09",
            },
            {
              childName: "台灣味道——部分台菜餐廳介紹",
              type_id: "09",
            },
            {
              childName: "當地伴手禮",
              type_id: "09",
            },
          ],
        },
        {
          type_name: "部分知名企業及創新創業基地簡介",
          type_id: "10",
          child: [
            {
              childName: "部分知名企業",
              type_id: "10",
            },
            {
              childName: "中芬設計園",
              type_id: "10",
            },
            {
              childName: "赛格眾創空間",
              type_id: "10",
            },
            {
              childName: "前海深港青年夢工廠",
              type_id: "10",
            },
          ],
        },
        {
          type_name: "深圳交通",
          type_id: "11",
          child: [
            {
              childName: "深圳交通",
              type_id: "",
            },
            // {
            //   childName:'深圳地鐵路線圖',
            //   type_id:'11',
            // },
            // {
            //   childName:'高鐵站',
            //   type_id:'11',
            // },
            // {
            //   childName:'火車站',
            //   type_id:'11',
            // },
            // {
            //   childName:'寶安國際機場',
            //   type_id:'11',
            // },
            // {
            //   childName:'深圳的口岸',
            //   type_id:'11',
            // }
          ],
        },
        {
          type_name: "求助",
          type_id: "12",
          child: [
            {
              childName: "台灣居民救助機構和主要聯繫方式",
              type_id: "12",
            },
            {
              childName: "深圳台商協會簡介",
              type_id: "12",
            },
            {
              childName: "備註：兩岸出入境攜帶現金及物品指南",
              type_id: "12",
            },
            {
              childName: "台灣居民深圳指南-i深圳篇",
              type_id: "12",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  methods: {
    toOutSideUrl(type_id, idx) {
      let filePath =
        idx !== ""
          ? `tsh-sz-guide:${type_id}:${idx}.pdf`
          : `tsh-sz-guide:${type_id}.pdf`;
      // console.log(filePath);

      window.open(this.$imgUrl + filePath, "_blank");
    },
  },
  watch: {
   
  },
  mounted() {
    
  },
};
</script>

<style lang="less" scoped>
.guide {
  background: #f2f2f2;
  padding: 50px 0;
}
.guide-menu {
  width: 1200px;
  margin: auto;
}
.guide-type {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px 20px 5px;
  margin-bottom: 10px;
  h3 {
    font-family: MicrosoftYaHei;
    font-size: 18px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 400;
    display: flex;
    align-items: center;
    white-space: nowrap;
    img {
      width: 28px;
      height: 28px;
      margin-right: 8px;
      object-fit: contain;
    }
  }
  ul {
    margin-left: 20px;
  }
  li {
    float: left;
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #222222;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 400;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    padding: 5px 12px;
    cursor: pointer;
    margin-bottom: 5px;
    margin-right: 5px;
  }
  li:hover {
    background: #20317f;
    color: #ffffff;
  }
}

.m-guide-menu {
  .el-menu-vertical-demo {
    width: 100%;
  }
  .icon {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }

  .el-menu-item-group ul li {
    margin: 0 30px;
    padding: 0 !important;
    border-bottom: 1px solid #eee;
  }
}
@media screen and (max-width: 768px) {
  .guide {
  background: #fff;
  padding: 30px 0;
}
}
</style>
<style  >
.m-guide-menu .el-menu-item-group__title {
  display: none;
}
.m-guide-menu .el-menu-vertical-demo .el-menu-item.is-active {
  background: none !important;
  color: #333;
}
.m-guide-menu .el-menu-item.is-active {
  color: #333;
  background: none !important;
}
</style>